import React, { useEffect, useState } from 'react';
import ChatAgentReports from './chatagents/new/Reports/ChatAgentReports';
import type { Theme } from './chatagents/new/Reports/types';

const AnalyticsHub: React.FC = () => {
  const [theme, setTheme] = useState<Theme>('dark');

  useEffect(() => {
    const activeTheme = document.documentElement.getAttribute('data-theme');
    setTheme(activeTheme === 'white' ? 'light' : 'dark');
  }, []);

  return <ChatAgentReports theme={theme} />;
};

export default AnalyticsHub;
